module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/6@2x_026e5664bc48c1410d83bd476f6a67ba.png";